import withAlmToken from '../../common/withAlmToken';
import EditProfileFrom from './EditProfileFrom';

const EditProfile = () => {
  return (
    <>
      <EditProfileFrom />
    </>
  );
};

export default withAlmToken(EditProfile);
